typeof window !== 'undefined' &&
    !window.__DS_WEB_VERSION__ &&
    (window.__DS_WEB_VERSION__ = '2.4.0');
const isLurkerOnPage = () => {
    if (typeof window === 'undefined')
        return false;
    return !!window.Lurker;
};
/**
 * Componente Lurker do Design System OLX
 */
export const sendToLurker = ({ eventType, objectDetail, objectName, data }) => {
    if (!isLurkerOnPage())
        return;
    const payload = Object.assign({ event_type: eventType, object_detail: objectDetail, object_name: objectName }, data);
    window.Lurker.sendBeacon(payload, true);
};
